export enum KorrekturStepStatus {
	NOT_STARTED = "NOT_STARTED",
	IN_PROGRESS = "IN_PROGRESS",
	COMPLETED = "COMPLETED",
}

export interface KorrekturStepDTO {
	id: string;
	isCurrentUser: boolean;
	locked: boolean;
	status: KorrekturStepStatus;
	stepNr: number;
	color: string;
}

export interface KorrekturOverviewDTO {
	id: string;
	title: string;
	internalIdentifier: string;
	korrekturSteps: KorrekturStepDTO[];
}

export interface AvailableKlausurDTO {
	id: string;
	title: string;
	korrekturStepsForUser: number;
	availableKorrekturStepsForUser: number;
	completedKorrekturStepsForUser: number;
	deadline?: Date;
}
